import React, { useEffect, useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink, useNavigate } from "react-router-dom";
import axios from 'axios';
import { baseurladdress } from "../baseurl";
import { Modal, ModalFooter } from "react-bootstrap";

function Leaveassignment() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const Swal = require('sweetalert2');
    const navigate = useNavigate();

    const [leavelist, setleavelist] = useState(false);

    const [branches, setBranches] = useState([]);
    const [stafflist, setstafflist] = useState([]);

    const [leavepolicylist, setleavepolicylist] = useState([]);
    const [filteredLeavePolicies, setFilteredLeavePolicies] = useState([]);

    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
const today = new Date().toISOString().split("T")[0];
    const [affectedfrom, setaffectedfrom] = useState(today);
    const [affectedto, setaffectedto] = useState("");

    const [employeeName, setEmployeeName] = useState("");

    const [selectedValue, setSelectedValue] = useState('');
    const [unused, setunused] = useState(0);

    const [leaveTypeIDs, setLeaveTypeIDs] = useState([]);
    const [leaveTypeNames, setLeaveTypeNames] = useState([]);
    const [leaveMaxes, setLeaveMaxes] = useState([]);
    const [policyDetails, setPolicyDetails] = useState([]);

    // ---------------- BRANCH ----------------
    const getbranch = () => {
        axios.get(baseurladdress + `findallbranches`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then(res => setBranches(res.data.response))
        .catch(err => alert(err));
    };

    // ---------------- STAFF BY BRANCH (NEW API) ----------------
    const getStaffByBranch = (branchName) => {
        if (!branchName) {
            setstafflist([]);
            return;
        }

        axios.post(
            baseurladdress + `getstaffbybranchess`,
            { branch_name: branchName },
            { headers: { Authorization: `Bearer ${accesstoken}` } }
        )
        .then(res => {
            setstafflist(res.data.response || []);
        })
        .catch(err => {
            console.error(err);
            setstafflist([]);
        });
    };

    // ---------------- LEAVE POLICY ----------------
    const getLeavePoliciesByBranch = (branchId) => {
        if (!branchId) return setleavepolicylist([]);

        axios.get(baseurladdress + `findleavepolicytest/${branchId}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then(res => {
            const data = res.data.response || [];
            setleavepolicylist(data);
            setFilteredLeavePolicies(data);
        })
        .catch(() => setleavepolicylist([]));
    };

    useEffect(() => {
        getbranch();
    }, []);

    // ---------------- POLICY SELECT ----------------
    const handleSelectChange = (event, policySource = leavepolicylist) => {
        const policyNum = event.target.value;
        setSelectedValue(policyNum);

        const policyObj = policySource.find(i => i.leavepolicy_num === policyNum);
        setSelectedPolicy(policyObj);

        if (!policyObj) return;

        const names = policyObj.leavepolicy_leavetype?.split(",") || [];
        const ids = policyObj.leavepolicy_leavetypeid?.split(",") || [];
        const maxs = policyObj.max_leave?.split(",") || [];

        const rows = ids.map((id, i) => ({
            id: id?.trim(),
            name: names[i]?.trim() || "",
            max: maxs[i]?.trim() || ""
        }));

        setLeaveTypeIDs(rows.map(r => r.id));
setLeaveTypeNames(rows.map(r => r.name));
setLeaveMaxes(rows.map(r => r.max));

// remove duplicate leave names
const uniqueLeaveNames = [...new Set(rows.map(r => r.name))];

setPolicyDetails(uniqueLeaveNames);
    };

    // ---------------- SUBMIT ----------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedBranch || !selectedStaff) {
            return Swal.fire("Error", "Select branch and staff", "error");
        }

        const data = {
             leaveassign_fromdate: affectedfrom,
    leaveassign_todate: affectedto || null,
            leaveassign_brnchid: selectedBranch.branch_id,
            leaveassign_brnchname: selectedBranch.branch_name,
            leaveassign_empid: selectedStaff.staff_id,
            leaveassign_empname: selectedStaff.staff_name,
            leaveassign_policyid: selectedPolicy?.leavepolicy_id,
            leaveassign_policynum: selectedPolicy?.leavepolicy_num,
            leaveassign_carryfrwrd: unused,
            leaveassign_leavetypeid: leaveTypeIDs,
            leaveassign_leavetypename: leaveTypeNames,
            leaveassign_totalleave: leaveMaxes,
            userid: accessuserid
        };

        const res = await fetch(baseurladdress + `addleaveassign`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        });

        const result = await res.json();

        if (result.status === "success") {
            Swal.fire("Success", "Leave Assigned", "success");
            navigate("/leaveassignmentlist");
        } else {
            Swal.fire("Error", result.message, "error");
        }
    };

    return (
        <div>
            <Topnavbar />
            <Sidennav />

            <div className="content-wrap">
                <div className="container-fluid">

                    <NavLink to={"/leaveassignmentlist"}>
                        <div style={{ display: "flex" }}>
                            <a className="float">
                                <i className="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>

                    <form>
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add Leave Assignment</h4>
                                
                            </div>

                            <div className="card-body">
                                <div className="row">

                                    {/* FROM */}
                                   <div className="col-md-3">
    <label>From</label>
    <input
        type="date"
        className="form-control"
        value={affectedfrom}
        onChange={e => setaffectedfrom(e.target.value)}
    />
</div>

                                    {/* TO */}
                                   <div className="col-md-3">
    <label>To</label>
    <input
        type="date"
        className="form-control"
        value={affectedto}
        onChange={e => setaffectedto(e.target.value)}
    />
</div>

                                    {/* BRANCH */}
                                    <div className="col-md-3">
                                        <label>Branch</label>
                                        <select
                                            className="form-control"
                                            onChange={(e) => {
                                                const branch = branches.find(b => b.branch_name === e.target.value);
                                                setSelectedBranch(branch);

                                                // 🔥 LOAD STAFF FROM API
                                                getStaffByBranch(branch?.branch_name);

                                                getLeavePoliciesByBranch(branch?.branch_id);

                                                setSelectedStaff(null);
                                                setstafflist([]);
                                            }}
                                        >
                                            <option value="">Choose</option>
                                            {branches.map(b => (
                                                <option key={b.branch_id} value={b.branch_name}>
                                                    {b.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* STAFF (FILTERED) */}
                                    <div className="col-md-3">
                                        <label>Staff Code</label>
                                        <select
                                            className="form-control"
                                            value={selectedStaff?.staff_code || ""}
                                            onChange={(e) => {
                                                const staff = stafflist.find(s => s.staff_code === e.target.value);
                                                setSelectedStaff(staff);
                                                setEmployeeName(staff?.staff_name || "");
                                            }}
                                        >
                                            <option value="">Choose</option>
                                            {stafflist.map(s => (
                                                <option key={s.staff_id} value={s.staff_code}>
                                                    {s.staff_code}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* STAFF NAME */}
                                    <div className="col-md-3">
                                        <label>Name</label>
                                        <input className="form-control" value={employeeName} readOnly />
                                    </div>

                                    {/* POLICY */}
                                    <div className="col-md-3">
                                        <label>Policy</label>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <select
                                                className="form-control"
                                                value={selectedValue}
                                                onChange={handleSelectChange}
                                                style={{ marginRight: "8px" }}
                                            >
                                                <option value="">Choose</option>
                                                {filteredLeavePolicies.map(p => (
                                                    <option key={p.leavepolicy_id} value={p.leavepolicy_num}>
                                                        {p.leavepolicy_num}
                                                    </option>
                                                ))}
                                            </select>
                                            {selectedValue && (
                                                <i
    className="fa fa-info-circle"
    style={{
        cursor: "pointer",
        color: "#20cce3",
        fontSize: "14px",
        marginLeft: "5px"
    }}
    onClick={() => setleavelist(true)}
></i>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                                            <div className="col-12 d-flex justify-content-center mt-4">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-3"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                                </div>

                            </div>
                        </div>
                    </form>

                </div>

                <Modal className="modal-size md modal-top-center" show={leavelist} style={{ display: "flex" }}>
                    <Modal.Header>
                        <h6>Leave List</h6>
                        <span
                            aria-hidden="true"
                            style={{ cursor: "pointer" }}
                            onClick={() => setleavelist(false)}
                        >
                            ×
                        </span>
                    </Modal.Header>
                    <Modal.Body className="css">
                        <ul className="list-unstyled">
                            {policyDetails.length > 0 ? (
                                policyDetails.map((leaveName, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            padding: "10px",
                                            color: "#007bff",
                                            borderBottom: index !== policyDetails.length - 1 ? "1px solid #ddd" : "none",
                                        }}
                                    >
                                        {leaveName}
                                    </li>
                                ))
                            ) : (
                                <li style={{ padding: "10px", color: "#999" }}>No leave types found for this policy.</li>
                            )}
                        </ul>
                    </Modal.Body>
                    <ModalFooter>
                        <div className="row w-100">
                            <div className="col-auto ml-auto">

                            </div>
                        </div>
                    </ModalFooter>
                </Modal>

            </div>
        </div>
    );
}

export default Leaveassignment;